import { getTestIds } from '../../../utils/TestIds';
export const GetTokenPickerTID = (parentTestId)=>getTestIds(parentTestId);
